module.exports = __webpack_public_path__ + "img/L2.65bff9b9.svg";